import { Agreement } from 'types/Agreement';

export interface AgreementsState {
    loading: boolean;
    status: AgreementsStatus;
    agreements: Array<Agreement>;
}

export enum AgreementsStatus {
    Error,
    Initial,

    FetchStart,
    FetchSuccess
}
